import { useEffect, useRef } from "react";
import type { WellGeoData } from "@/store/geo-test/types";
import { HEADER_HEIGHT, useMetaContext } from "../../base";
import { useGeoData } from "../../utils";
import { GeoChartBodyColumn } from "./GeoChartBodyColumn";
import { GeoChartBodyPictureWrapper } from "./GeoChartBodyPictureWrapper";

export const GeoChartBody = () => {
	const { geoData, divColumnsBodyRef } = useGeoData();
	const meta = useMetaContext();

	const containerRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (geoData && geoData.wells.length > 0 && containerRef.current) {
			const findMinDepth = (wells: WellGeoData[]) => {
				const allDepths = wells.flatMap((well) =>
					well.stratums.map((stratum) => stratum.start),
				);

				return Math.min(...allDepths);
			};
			const minDepth = findMinDepth(geoData.wells);

			containerRef.current.scrollTo({
				top: meta.depths.depthToPixelsY(minDepth - 50),
				behavior: "smooth",
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [geoData.wells.map(({ wellId }) => wellId).join(";")]);

	return (
		<div
			ref={containerRef}
			className="overflow-y-scroll bg-white w-fit dark:bg-block-secondary"
			style={{ height: meta.container.height - HEADER_HEIGHT }}
		>
			<div
				ref={divColumnsBodyRef}
				style={{ height: meta.content.height }}
				className="flex border-l border-r "
			>
				{meta.columns.map((c) => {
					return (
						<GeoChartBodyColumn column={c} key={c.key} geoData={geoData} />
					);
				})}
				<GeoChartBodyPictureWrapper />
			</div>
		</div>
	);
};
